import React, { useState, useEffect } from 'react';
import { getArtisanCategoriesAction } from '../../../modules/artisanJobCategories/Actions';
import {
  artisanCategoriesListSelector,
  artisanCategoriesIsLoadingSelector,
  artisanCategoriesCountSelector,
  searchValueSelector
} from '../../../modules/artisanJobCategories/Selectors';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FormattedMessage, injectIntl } from 'react-intl';
import getLangData from '../../../utils/getLangData';
import langText from '../../../utils/langText';

const ArtisanCategoriesList = props => {
  const {
    artisanCategories,
    isLoading,
    getArtisanCategories,
    artisanCategoriesCount,
    searchValue
  } = props;

  const [size, setSize] = useState(10);

  const [offset, setOffset] = useState(0);

  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    getArtisanCategories({
      size,
      offset,
      searchTerm: searchValue,
      hasParent: ''
    });
  }, [getArtisanCategories, searchValue]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (artisanCategories.length >= artisanCategoriesCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getArtisanCategories({
      size,
      offset: artisanCategories.length,
      searchTerm: searchValue
    });
  };

  //
  const dataLength =
    artisanCategories.length <= artisanCategoriesCount
      ? artisanCategories.length
      : artisanCategoriesCount;

  return (
    <InfiniteScroll
      next={fetchMore}
      hasMore={hasMore}
      dataLength={dataLength}
      style={{ overflow: 'hidden' }}
    >
      {console.log(artisanCategories, 'artisanCategories')}
      <div className='table row block--container my-5'>
        <List
          isLoading={isLoading}
          header={{ items: [getLangData().fields.name], actions: ['Edit'] }}
          items={artisanCategories}
        >
          <table className='table'>
            <tbody>
              {artisanCategories.map(({ name, _id, namei18n, parentId }) => (
                <ListItem
                  key={_id}
                  name={langText(name, namei18n)}
                  editLink={`/job/artisan-categories/${_id}`}
                  wordLabel={!parentId && 'Parent'}
                />
              ))}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
    /*   <Table
      columns={[
        { title: "Name", dataIndex : 'name' , column: "1", span: "10" },
        { title: "Actions", dataIndex: '_id' , column: "11", span: "2" },
      ]}
    /> */
  );
};

const mapStateToProps = state => ({
  artisanCategories: artisanCategoriesListSelector(state),
  isLoading: artisanCategoriesIsLoadingSelector(state),
  artisanCategoriesCount: artisanCategoriesCountSelector(state),
  searchValue: searchValueSelector(state)
});

export default injectIntl(
  connect(mapStateToProps, {
    getArtisanCategories: getArtisanCategoriesAction
  })(ArtisanCategoriesList)
);

const dynamicGrid = ({ column, span }) => css`
  grid-column: ${column} / span ${span};
`;

const Container = styled.div`
  display: block;
  width: 100%;
  background-color: #fff;
`;

const TableCell = styled.div`
  ${dynamicGrid}
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

/* const TableRow = ({children ,column , data}) => {
  return (
    <>
   {data.map((child , index) => {
      return <TableCell key={index} column={`${column[index].column}`} span={`${column[index].span}`}>{child}</TableCell>
    })}} 
    </>
  )
} */

/* const TableItem = (data) => (
  <TableRow>
    <TableCell column='1' span='10'>
      {name}
    </TableCell>

    <TableCell column='11' span='2'>
      <Link to={Edit} className='btn-label-brand btn btn-sm btn-bold'>
        Edit
      </Link>
    </TableCell>

  </TableRow>
); */

const Table = ({ columns, children }) => {
  const map = {};
  columns.forEach(column => {
    map[column.dataIndex] = column;
  });

  return (
    <Container>
      <TableRow>
        {columns.map(({ title, column, span }, index) => (
          <TableCell key={index} column={column} span={span}>
            {title}
          </TableCell>
        ))}
      </TableRow>

      {/*     {children.map(data => (
        <TableRow column={columns}  data={[data]}/>
      ))}
 */}
      {/*       {Children.map(children , child => {
          return <TableRow column={columns}>{child}</TableRow>
        })} */}
    </Container>
  );
};
